<template>
  <div class="reimburseList">
    <OATable
      ref="reimburseList"
      :data="data"
      :columns="columns"
      :filterData="filterData"
      :loading="loading"
      @search="handleSearch"
    ></OATable>
  </div>
</template>
<script>
import reimburseApi from "@/services/reimburse.js";
import OAHandle from "@/components/OAHandle/OAHandle";
import OAJump from "@/components/OAJump/OAJump";
import { download } from "@/common/util";

export default {
  name: "reimburseList",
  components: { OAHandle, OAJump },
  data() {
    let that = this;
    return {
      filterData: {
        spnum: {
          formType: "a-input",
          value: undefined,
          col: 4,
          placeholder: "审批单号"
        },
        spStatus: {
          formType: "a-select",
          value: undefined,
          placeholder: "审批状态",
          api: "getApprovalStatus",
          col: 4,
          format: function(data) {
            let res = data.filter(item => {
              return (
                item.code === 1 ||
                item.code === 2 ||
                item.code === 3 ||
                item.code === 12
              );
            });
            return res;
          }
        },
        applyTime: {
          formType: "a-date-picker",
          type: "daterange",
          value: undefined,
          startPlaceholder: "申请开始时间",
          endPlaceholder: "申请结束时间",
          col: 4
        }
      },
      columns: [
        {
          title: "审批单号",
          component: {
            name: OAJump,
            props: {
              textKey: "spNum",
              url: "reimburseDetail",
              paramKey: "id",
              query: {
                type: 1
              }
            }
          }
        },
        {
          title: "审批人",
          key: "approvalName"
        },
        {
          title: "审批状态",
          key: "spStatusName"
        },
        {
          title: "申请时间",
          key: "applyTime"
        },
        {
          title: "操作",
          key: "spStatus",
          width: 110,
          component: {
            name: OAHandle,
            props: {
              text: "下载PDF",
              isShow: "spStatus==2",
              onClick: function(val) {
                that.download(val.row.id);
              }
            }
          }
        }
      ],
      data: [],
      loading: false
    };
  },
  mounted() {},
  methods: {
    async handleSearch(val) {
      val["type"] = 2;
      this.loading = true;
      this.param = val;
      let res = await reimburseApi.getApproval(val);
      this.data = res.data.data;
      this.loading = false;
    },
    async download(id) {
      let res = await reimburseApi.downloadpdf({ id: id });
      download(res.data.data);
    }
  }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/self/reimburseList.vue